import React, { Component } from "react"
import PropTypes from "prop-types"
import moment from "moment"

import {
    createNumericTripletMultiFilter,
    datePickerGenericFilter,
    enumSingleGenericFilter,
    enumOrderSort,
} from "shared/search/containers/Filter/Filters"

import { searchifySelectGenericFilter } from "shared/search/containers/Filter/FilterCreators"

import {
    UserFilterableListView,
    OfficialInOutboxFilterableListView,
    SupporterFilterableListView,
    IssueManagementFilterableListView,
    StafferFilterableListView,
    PressContactFilterableListView,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import {
    IssueManagementSelect,
    ContactSelect,
    UserSelect,
    OfficialSelect,
    StafferSelect,
    PressContactSelect,
} from "app/static/frontend/selects/containers/PieSelect"

const defaultEnumPropTypes = {
    displayLabel: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,

    enumItems: PropTypes.array,
    helpText: PropTypes.string,
    sortBy: PropTypes.func,
}

export class BulkEmailProjectFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "BulkEmailProjectFilter",
            filterKey: "for_project_and_subprojects",
            searchifyFLV: IssueManagementFilterableListView,
            dataTypeLabel: "Projects",
            selectComponent: IssueManagementSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BulkEmailOfficialReceivedFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "BulkEmailMemberReceivedFilter",
            filterKey: "received_by_official",
            searchifyFLV: OfficialInOutboxFilterableListView,
            selectComponent: OfficialSelect,
            dataTypeLabel: "Emailed Officials",
            displayLabel: "Emailed",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BulkEmailStafferReceivedFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "BulkEmailStafferReceivedFilter",
            filterKey: "received_by_staffer",
            searchifyFLV: StafferFilterableListView,
            selectComponent: StafferSelect,
            dataTypeLabel: "Emailed Officials",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BulkEmailPressContactReceivedFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "BulkEmailPressContactReceivedFilter",
            filterKey: "received_by_press",
            searchifyFLV: PressContactFilterableListView,
            selectComponent: PressContactSelect,
            dataTypeLabel: "Emailed Press",
            permissions: [DjangIO.app.models.PermissionType.media_relations],
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BulkEmailOfficialOpenedFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "BulkEmailOfficialOpenedFilter",
            filterKey: "opened_by_official",
            searchifyFLV: OfficialInOutboxFilterableListView,
            dataTypeLabel: "Clicked Officials",
            displayLabel: "Clicked",
            selectComponent: OfficialSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BulkEmailStafferOpenedFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "BulkEmailStafferOpenedFilter",
            filterKey: "opened_by_staffer",
            searchifyFLV: StafferFilterableListView,
            dataTypeLabel: `Clicked ${DjangIO.app.models.QuorumDataType.staffer.plural}`,
            selectComponent: StafferSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BulkEmailPressContactOpenedFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "BulkEmailPressContactOpenedFilter",
            filterKey: "opened_by_press",
            searchifyFLV: PressContactFilterableListView,
            dataTypeLabel: "Clicked Press",
            selectComponent: PressContactSelect,
            permissions: [DjangIO.app.models.PermissionType.media_relations],
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BulkEmailOfficialClickedFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "BulkEmailOfficialClickedFilter",
            filterKey: "clicked_by_official",
            searchifyFLV: OfficialInOutboxFilterableListView,
            dataTypeLabel: "Opened Officials",
            displayLabel: "Opened",
            selectComponent: OfficialSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BulkEmailStafferClickedFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "BulkEmailStafferClickedFilter",
            filterKey: "clicked_by_staffer",
            searchifyFLV: StafferFilterableListView,
            dataTypeLabel: `Opened ${DjangIO.app.models.QuorumDataType.staffer.plural}`,
            selectComponent: StafferSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BulkEmailPressContactClickedFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "BulkEmailPressContactClickedFilter",
            filterKey: "clicked_by_press",
            searchifyFLV: PressContactFilterableListView,
            dataTypeLabel: "Opened Press",
            selectComponent: PressContactSelect,
            permissions: [DjangIO.app.models.PermissionType.media_relations],
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BulkEmailSupporterReceivedFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "BulkEmailSupporterReceivedFilter",
            filterKey: "received_by_supporter",
            searchifyFLV: SupporterFilterableListView,
            selectComponent: ContactSelect,
            dataTypeLabel: "Emailed Contacts",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BulkEmailSupporterOpenedFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "BulkEmailSupporterOpenedFilter",
            filterKey: "opened_by_supporter",
            searchifyFLV: SupporterFilterableListView,
            dataTypeLabel: "Clicked Contacts",
            selectComponent: ContactSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BulkEmailSupporterClickedFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "BulkEmailSupporterClickedFilter",
            filterKey: "clicked_by_supporter",
            searchifyFLV: SupporterFilterableListView,
            dataTypeLabel: "Opened Contacts",
            selectComponent: ContactSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const BulkEmailDateFilter = (props) => {
    const FilterComponent = props.filterComponent || enumSingleGenericFilter
    return <FilterComponent {...props} />
}
BulkEmailDateFilter.propTypes = defaultEnumPropTypes
BulkEmailDateFilter.defaultProps = {
    filterComponent: enumSingleGenericFilter,
    uniqueFilterId: "bulkEmailDateFilter",
    filterKey: "date_range",
    enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items().filter(
        (item) => ![DjangIO.app.events.models.DateRangeType.this_year.value].includes(item.value),
    ),
    sortBy: enumOrderSort,
    displayLabel: "Date Created",
    helpText:
        "Filter for results that were added to Quorum after a particular date " + "or within a specific date range.",
}

export class BulkEmailSentDateAfterFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "BulkEmailSentDateAfterFilter",
        filterKey: "sent_datetime__gt",
        displayLabel: "Sent After",
        helpText: "Outbox emails sent after date selected. Excludes date selected.",
        minDate: moment().subtract(1, "years").toISOString(),
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BulkEmailSentDateBeforeFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "BulkEmailSentDateBeforeFilter",
        filterKey: "sent_datetime__lt",
        displayLabel: "Sent Before",
        helpText: "Outbox emails sent before date selected. Excludes date selected.",
        minDate: moment().subtract(1, "years").toISOString(),
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BulkEmailSentFromFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "BulkEmailSentFromFilter",
            filterKey: "sent_by_user",
            searchifyFLV: UserFilterableListView,
            dataTypeLabel: "Sent From",
            displayLabel: "Sent From",
            selectComponent: UserSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BulkEmailCreatedByFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "BulkEmailCreatedByFilter",
            filterKey: "created_by_user",
            searchifyFLV: UserFilterableListView,
            dataTypeLabel: "Creator",
            displayLabel: "Creator",
            selectComponent: UserSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const BulkEmailNumberSentFilter = createNumericTripletMultiFilter({
    uniqueFilterId: "BulkEmailNumberSentFilter",
    baseFilterKey: "email_count",
    displayLabel: "Sent",
})

export const BulkEmailNumberOpensFilter = createNumericTripletMultiFilter({
    uniqueFilterId: "BulkEmailNumberOpensFilter",
    baseFilterKey: "opens",
    displayLabel: "Opens",
})

export const BulkEmailNumberClicksFilter = createNumericTripletMultiFilter({
    uniqueFilterId: "BulkEmailNumberClicksFilter",
    baseFilterKey: "clicks",
    displayLabel: "Clicks",
})
